export const readAsDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

export const readAsBytes = async (blob) => new Uint8Array(await blob.arrayBuffer());

export const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("อ่านรูปภาพไม่สำเร็จ"));
    img.src = src;
  });

/**
 * แปลงรูปจากเครื่องให้ pdf-lib ฝังได้ (PNG/JPEG) และย่อถ้าใหญ่เกิน maxDim
 * @param removeWhite ทำพื้นหลังสีขาวให้โปร่งใส (ใช้กับรูปลายเซ็นที่ถ่าย/สแกน)
 * @returns { dataUrl, width, height }
 */
export async function prepareImage(file, { maxDim = 2400, removeWhite = false } = {}) {
  const source = await readAsDataUrl(file);
  const img = await loadImage(source);
  const isPng = file.type === "image/png";
  const isJpeg = file.type === "image/jpeg";

  if (!removeWhite && (isPng || isJpeg) && Math.max(img.width, img.height) <= maxDim) {
    return { dataUrl: source, width: img.width, height: img.height };
  }

  const ratio = Math.min(1, maxDim / Math.max(img.width, img.height));
  const width = Math.max(1, Math.round(img.width * ratio));
  const height = Math.max(1, Math.round(img.height * ratio));
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);

  if (removeWhite) {
    const data = ctx.getImageData(0, 0, width, height);
    const px = data.data;
    for (let i = 0; i < px.length; i += 4) {
      const min = Math.min(px[i], px[i + 1], px[i + 2]);
      // ยิ่งขาวยิ่งโปร่งใส (เริ่มจาง 200 -> โปร่งใสเต็ม 245) กันขอบหยัก
      if (min >= 245) px[i + 3] = 0;
      else if (min > 200) px[i + 3] = Math.round(px[i + 3] * (1 - (min - 200) / 45));
    }
    ctx.putImageData(data, 0, 0);
  }

  const keepJpeg = isJpeg && !removeWhite;
  return { dataUrl: canvas.toDataURL(keepJpeg ? "image/jpeg" : "image/png", 0.92), width, height };
}

export const dataUrlToBytes = (dataUrl) => {
  const bin = atob(String(dataUrl).split(",").pop());
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
  return bytes;
};

export const bytesToDataUrl = (bytes, mime) => readAsDataUrl(new Blob([bytes], { type: mime }));
